import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/auth.service';
import { AuthFormVm } from '../models/auth.vm';
import { map, Observable, switchMap, tap } from 'rxjs';
import { AuthMapper } from '../mappers/auth.mapper';
import { SessionService } from '@core/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTE_AUTH, ROUTE_LOGIN } from '@core/config/route-paths.config';
import { IdentityFacade } from '@core/facades/identity.facade';

@Injectable({ providedIn: 'root' })
export class AuthFacade {
  constructor(
    private authService: AuthenticationService,
    private identityFacade: IdentityFacade,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  public login(data: AuthFormVm): Observable<void> {
    const request = AuthMapper.mapFormVmToRequest(data);

    return this.authService.login(request).pipe(
      tap((response) => {
        const auth = response.data;

        if (auth && auth.accessToken) {
          this.sessionService.saveSession(
            auth.accessToken,
            Number(auth.expiresIn),
          );
        }
      }),
      switchMap(() => this.identityFacade.getCurrentUser(true)),
      tap(() => {
        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.router.navigateByUrl(returnUrl);
      }),
      map(() => void 0),
    );
  }

  public logout(): void {
    this.sessionService.removeSession();
    this.identityFacade.clear();
    this.router.navigate([`/${ROUTE_AUTH}/${ROUTE_LOGIN}`]);
  }
}
